import { devtools, subscribeWithSelector } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";
import { createStore } from "zustand/vanilla";
import type { GPTSlotResponseStore, SlotResponseData } from "@/ts/types";

export const initialState = {
	slotsResponseInformation: {},
	takeoverDetectionData: {
		takeoverSlots: [],
		sponsorshipDetected: false,
	},
};

export const gptSlotResponseStore = createStore<GPTSlotResponseStore>()(
	devtools(
		subscribeWithSelector(
			immer((set, _get) => ({
				...initialState,
				actions: {
					setSlotsResponseInformation: (
						responseInfo: Record<string, SlotResponseData>,
					) =>
						set((state) => {
							state.slotsResponseInformation = {
								...state.slotsResponseInformation,
								...responseInfo,
							};
						}),
					setTakeoverDetection: (
						takeoverSlots: string[],
						sponsorshipDetected: boolean,
					) =>
						set((state) => {
							state.takeoverDetectionData = {
								...state.takeoverDetectionData,
								takeoverSlots,
								sponsorshipDetected,
							};
						}),
				},
			})),
		),
		{
			name: "Hydra-GPTSlotResponseStore",
		},
	),
);
